module.exports = __webpack_public_path__ + "static/img/Immune Health Circle@2x.69a37a5b.png";